export default __webpack_public_path__ + "media/popper.ad4d49ed.svg";